module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/is-pure.js
// module id = 47
// module chunks = 0